import { LayoutProps } from 'components/atoms/Layout/interfaces'
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces'
import { FormThirdGuarantorKeys } from 'pages/Contracts/Components/Forms/FormThirdGuarantor/types'

interface Schema {
   id: FormThirdGuarantorKeys
}

export const ViewThirdGuarantorValue = (): {
   input?: InputBuildProps & Schema
   select?: SelectBuildProps & Schema
   layout: LayoutProps
}[] => [
      {
         input: {
            id: 'nome',
            label: 'Nome do terceiro garantidor',
            maxLength: 128
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
         }
      },
      {
         input: {
            id: 'email',
            label: 'Email',
            maxLength: 128
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
         }
      },
      {
         select: {
            id: 'tipoDocumento',
            label: 'Doc. terceiro garantidor',
            optionsType: 'doc'
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 4 }
         }
      },
      {
         input: {
            id: 'documento',
            label: 'Nº do documento',
            inputMode: 'numeric',
            maskReplace: 'registro'
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 4 }
         }
      },
      {
         input: {
            id: 'endereco.cep',
            label: 'CEP',
            maskReplace: 'cep',
            inputMode: 'numeric'
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 4 }
         }
      },
      {
         input: {
            id: 'endereco.municipio',
            label: 'Município'
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 5 }
         }
      },
      {
         select: {
            id: 'endereco.uf',
            label: 'UF',
            optionsType: 'uf'
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 2 }
         }
      },
      {
         input: {
            id: 'endereco.bairro',
            label: 'Bairro'
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 5 }
         }
      },
      {
         input: {
            id: 'endereco.logradouro',
            label: 'Logradouro'
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 10 }
         }
      },
      {
         input: {
            id: 'endereco.numero',
            label: 'Número'
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 2 }
         }
      },
      {
         input: {
            id: 'telefone',
            label: 'Telefone',
            inputMode: 'numeric',
            maskReplace: 'contato'
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 5 }
         }
      },
      {
         input: {
            id: 'endereco.complemento',
            label: 'Complemento ou referência'
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 7 }
         }
      }
   ]